import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const retailCashApiPath = `${BASE_PATH_API}/paynearme`;

const actions = {
    getPayNearMeResidents: {
        method: 'GET',
        url: `${retailCashApiPath}/residents`,
        params: {
            '$count': true
        }
    },
    getPayNearMeProperties: {
        method: 'GET',
        url: `${retailCashApiPath}/properties`
    },
    provisionResident: {
        url: `${retailCashApiPath}/userLeases/:userLeaseId/provision`,
        method: 'POST'
    },
    updateResidentEnableStatus: {
        url: `${retailCashApiPath}/userLeases/:userLeaseId/status`,
        method: 'PUT'
    },
    getResidentPayslipUrl: {
        url: `${retailCashApiPath}/userLeases/:userLeaseId/payslip`,
        method: 'GET'
    },
    createBankAccount: {
        url: `${retailCashApiPath}/bankAccounts/:glAccountId`,
        method: 'POST'
    },
    getActiveBankAccountsAsOptions: {
        url: `${retailCashApiPath}/bankAccounts/activeBankAccountsMinimal`,
        method: 'GET'
    },
    getBankAccountMembershipStatus: {
        url: `${retailCashApiPath}/bankAccounts/:glAccountId/membershipStatus`,
        method: 'GET'
    },
    getBankAccountOwnerDetails: {
        url: `${retailCashApiPath}/bankAccounts/bankAccountOwners`,
        method: 'GET'
    },
    getRetailCashAccountEligibility: {
        url: `${retailCashApiPath}/bankAccounts/pnmBankApplication/accountEligibility`,
        method: 'GET'
    }
};

export function RetailCashApi() {
    return createActions(actions);
}
